///
/// EarthBrowser
///
/// Wildfire Browser Feature
///
/// Manages wildfire browser window lifecycle and command palette registration
///
/// Created by Matt Giger on 9/5/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useEffect } from 'react'
import { Flame } from 'lucide-react'
import { WildfireBrowserRenderer } from '@/components/features/wildfire-browser/WildfireBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const WILDFIRE_WINDOW_ID = 'wildfire-browser'
const WILDFIRE_WINDOW_WIDTH = 780
const WILDFIRE_WINDOW_HEIGHT = 500

export function WildfireBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const wildfireWindow = datasetWindows[WILDFIRE_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'wildfire-browser',
			command: {
				id: 'wildfires',
				title: 'Wildfires',
				icon: <Flame className="w-4 h-4 text-rose-500" />,
				category: 'Datasets',
				enabled: true,
				onSelect: () => {
					openOrRestoreWindow(
						dispatch,
						datasetWindows,
						WILDFIRE_WINDOW_ID,
						{
							id: WILDFIRE_WINDOW_ID,
							title: 'Wildfires',
							windowType: 'wildfire',
							x: 100,
							y: 100,
							width: WILDFIRE_WINDOW_WIDTH,
							height: WILDFIRE_WINDOW_HEIGHT,
							isMaximized: false,
							isVisible: true,
						}
					)
				}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!wildfireWindow) {
		return null
	}

	return (
		<WildfireBrowserRenderer
			windowId={WILDFIRE_WINDOW_ID}
			windowState={wildfireWindow}
		/>
	)
}
